import { type OwnerModels, ownerApi, ownerProperties } from "@/api/client/owner"
import { Button } from "@/components/ui/button"
import { openInNewTab } from "@/lib/navigation"
import { OwnerInfoTab } from "./OwnerInfoTab"

interface OwnerDetailContentProps {
  ownerId: string
}

export const OwnerDetailContent = ({ ownerId }: OwnerDetailContentProps) => {
  // 物件・部屋に加えて、運用ルール一覧(既定 + 物件固有)も同じ取得で展開する(E-13)
  const params: OwnerModels.OwnerGetParams = {
    withPropertiesRooms: ownerProperties.OwnerGetWithPropertiesRooms.true,
    withOperationRules: ownerProperties.OwnerGetWithOperationRules.true,
  }
  const {
    data: { owner },
    refetch,
  } = ownerApi.useOwnerGetSuspense(ownerId, params)

  // 同名オーナーの物件が混ざらないよう ID で絞り込む。オーナー名は検索欄の表示用
  const propertiesUrl = `/properties?ownerId=${encodeURIComponent(owner.id)}&ownerName=${encodeURIComponent(owner.name)}`

  return (
    <>
      <div className="flex items-center justify-end">
        <div className="flex gap-2.5">
          <Button variant="outline" onClick={() => openInNewTab(propertiesUrl)}>
            保有物件を見る
          </Button>
        </div>
      </div>
      <div>
        <OwnerInfoTab owner={owner} refetch={refetch} />
      </div>
    </>
  )
}
